/* eslint-disable no-magic-numbers */

import { useApi } from '@omnipresentgroup/api';
import type {
  CreateInvoiceQuoteRequest,
  CreateInvoiceQuoteResponse,
  CreateInvoiceQuoteResponseAPI,
} from '@omnipresentgroup/types';
import { useMutation } from '@tanstack/react-query';

import { transformContractorPaymentQuoteFromAPI } from '../../contractorsPayments/mappers';
import { API_BASE, API_PATH } from '../constants';
import { transformCreateInvoiceQuoteRequestToAPI } from '../mappers';

export const useCreateContractorInvoiceQuoteMutation = () => {
  const { POST } = useApi();

  return useMutation({
    mutationFn: (payload: CreateInvoiceQuoteRequest) => {
      const transformedPayload =
        transformCreateInvoiceQuoteRequestToAPI(payload);

      return new Promise<CreateInvoiceQuoteResponse>((resolve, reject) => {
        POST<CreateInvoiceQuoteResponseAPI>({
          path: `${API_BASE}/${API_PATH}/quotes`,
          body: transformedPayload,
        })
          .then((response) =>
            resolve(transformContractorPaymentQuoteFromAPI(response)),
          )
          .catch((error) => reject(error));
      });
    },
  });
};
